export default __webpack_public_path__ + "static/media/link.10b017da.svg";